import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import ButtonOrLink from './ButtonOrLink';

const Link = styled(ButtonOrLink)`
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: 0.2px;
  transition: color 300ms ease;

  &:not(.licensedBlade) {
    font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  }
  
  &:hover,
  &:focus {
    opacity: 0.8;
  }
`;

const PrimaryLink = styled(Link)`
  color: ${themeGet('colors.black')};

  span {
    text-decoration: underline;
    text-underline-offset: 0.1rem;
  }
`;

interface InlineLinkProps {
  className?: string;
  onClick?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onKeyDown?: (e: any) => void;
  submit?: boolean;
  href?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

const InlineLink = ({
  className,
  children,
  onClick,
  onKeyDown,
  submit,
  href,
  disabled,
  ariaLabel,
} : PropsWithChildren<InlineLinkProps>) => (
  <PrimaryLink
    className={className}
    onClick={onClick}
    onKeyDown={onKeyDown}
    submit={submit}
    href={href}
    ariaLabel={ariaLabel}
    disabled={disabled}
  >
    <span>{children}</span>
  </PrimaryLink>
);

export default InlineLink;
